<template>
  <div id="washingMachineList">
    <!-- 弹窗 -->
    <el-dialog
      v-model="dialogVisible"
      :title="`${form.id ? '编辑' : '绑定'}设备`"
      :width="$store.state.screenWidth > 1200 ? '700px' : '98%'"
      align-center
      @closed="dialogClosed"
      :close-on-click-modal="false"
    >
      <el-form :model="form" ref="formRef" :rules="rules">
        <el-form-item label="厂商" label-width="120px" prop="cid">
          <el-select
            v-model="form.cid"
            placeholder="请选择设备厂商"
            :disabled="form.bindChange || !!form.id"
          >
            <el-option
              v-for="item in deviceMgrData"
              :key="item.cid"
              :label="item.name"
              :value="item.cid"
            />
          </el-select>
        </el-form-item>
        <el-form-item
          label="门店代码"
          label-width="120px"
          prop="hotel_code"
          v-if="!props.data.id && (!form.id || form.bindChange)"
        >
          <el-input
            v-model="form.hotel_code"
            placeholder="请输入门店代码"
            clearable
          />
        </el-form-item>
        <el-form-item label="设备ID" label-width="120px" prop="devid">
          <el-input
            v-model="form.devid"
            placeholder="请输入设备ID"
            clearable
            :disabled="form.id || form.bindChange"
          />
        </el-form-item>
        <el-form-item label="设备名称" label-width="120px" prop="name">
          <el-input
            v-model="form.name"
            placeholder="请输入设备名称"
            clearable
            :disabled="form.bindChange"
          />
        </el-form-item>
        <el-form-item label="备注" show-overflow-tooltip label-width="120px">
          <el-input
            v-model="form.remark"
            :autosize="{ minRows: 2, maxRows: 4 }"
            type="textarea"
            maxlength="30"
            show-word-limit
            placeholder="请输入备注"
            :disabled="form.bindChange"
          />
        </el-form-item>
        <el-form-item label="状态" label-width="120px" prop="state">
          <el-switch
            v-model="form.state"
            :active-value="1"
            :inactive-value="0"
          />
        </el-form-item>
        <el-form-item label="排序" label-width="120px" prop="sort">
          <el-input-number
            v-model="form.sort"
            placeholder="值大的排在前面"
            clearable
            :disabled="form.bindChange"
            max="99999"
          />

          <div
            class="tips"
            style="
              margin-left: 8px;
              font-size: 14px;
              color: red;
              font-weight: bold;
            "
          >
            【 值大的排在前面 】
          </div>
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="dialogVisible = false">取消</el-button>
          <el-button type="primary" @click="dialogSubmit(formRef)"
            >确定</el-button
          >
        </span>
      </template>
    </el-dialog>
    <!-- 导入设备弹窗 -->
    <el-dialog
      v-model="dialogVisible2"
      title="导入设备"
      :width="$store.state.screenWidth > 1200 ? '700px' : '98%'"
      align-center
      @closed="dialogClosed2"
      :close-on-click-modal="false"
    >
      <el-form :model="form2" ref="formRef2" :rules="rules">
        <el-form-item
          label="门店代码"
          label-width="120px"
          prop="hotel_code"
          v-if="!props.data.id && (!form2.id || form2.bindChange)"
        >
          <el-input
            v-model="form.hotel_code"
            placeholder="请输入门店代码"
            clearable
          />
        </el-form-item>
        <el-form-item label="厂商" label-width="120px" prop="cid">
          <el-select
            v-model="form2.cid"
            placeholder="请选择设备厂商"
            :disabled="form2.bindChange || !!form2.id"
          >
            <el-option
              v-for="item in deviceMgrData"
              :key="item.cid"
              :label="item.name"
              :value="item.cid"
            />
          </el-select>
        </el-form-item>
        <el-form-item
          label="洗衣机门店列表"
          label-width="120px"
          prop="cid"
          v-if="form2.cid && deviceMgrMap[form2.cid].hasStores"
        >
          <el-select v-model="form2.store_id" placeholder="请选择洗衣机门店">
            <el-option
              v-for="item in storesData"
              :key="item.cid"
              :label="item.name"
              :value="item.cid"
            />
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="设备列表" label-width="120px" prop="cid">
          <el-select
            v-model="form2.devids"
            placeholder="请选择设备"
            multiple
            clearable
            :loading="devicesLoading"
          >
            <el-option
              v-for="item in devicesData"
              :key="item.cid"
              :label="item.name"
              :value="item.cid"
            />
            <template #loading>
              <div style="height: 100px" v-loading="devicesLoading"></div>
            </template>
          </el-select>
        </el-form-item> -->
        <el-form-item label="设备列表" label-width="120px" prop="cid">
          <el-table
            ref="multipleTable"
            :data="devicesData"
            tooltip-effect="dark"
            style="width: 100%"
            :border="false"
            :header-cell-style="{ backgroundColor: '#F4F7FB' }"
            :header-row-style="{
              backgroundColor: '#F4F7FB',
              color: '#1E2026',
            }"
            v-loading="devicesLoading"
            @selection-change="
              (value) => {
                form2.devids = value.map((item) => item.devid);
              }
            "
          >
            <el-table-column
              type="selection"
              :width="$store.state.screenWidth > 1200 ? 55 : 30"
            />
            <el-table-column prop="devid" label="设备ID" min-width="220">
            </el-table-column>
            <el-table-column prop="name" label="设备名称" min-width="150">
            </el-table-column>
            <el-table-column
              prop="type"
              label="设备类型"
              class-name="screen"
              min-width="150"
            >
              <template #default="scope">
                <el-tag
                  v-if="deviceTypeData.length"
                  disable-transitions
                  :type="
                    deviceTypeData.find((item) => item.id == scope.row.type)
                      .type
                  "
                  >{{
                    deviceTypeData.find((item) => item.id == scope.row.type)
                      .name
                  }}</el-tag
                >
                <div v-else>--</div>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="dialogVisible2 = false">取消</el-button>
          <el-button type="primary" @click="dialogSubmit2(formRef2)"
            >确定</el-button
          >
        </span>
      </template>
    </el-dialog>
    <!-- 头部 -->
    <div class="head">
      <div class="head_left">
        <el-button
          type="primary"
          icon="Download"
          v-if="data.code"
          @click="dialogVisible2 = true"
          >导入设备</el-button
        >
        <el-button
          type="primary"
          icon="Connection"
          @click="dialogVisible = true"
          >绑定设备</el-button
        >
        <el-button
          type="danger"
          icon="CircleClose"
          @click="washingMachineListUnbind(checkedData, 'all')"
          >解绑设备</el-button
        >
        <el-button
          type="danger"
          icon="Delete"
          @click="washingMachineListDel(checkedData, 'all')"
          v-if="!data.id"
          >删除设备</el-button
        >
      </div>
      <div class="head_right">
        <el-input
          v-model="washingMachineList_req.value"
          placeholder="请输入关键词"
          class="input-with-select"
          :clearable="true"
        >
          <template #append>
            <el-button icon="Search" @click="washingMachineListGet" />
          </template>
          <template #prepend>
            <el-select
              v-model="selectId"
              placeholder="Select"
              style="width: 100px"
            >
              <el-option
                v-for="(item, index) in selectData"
                :key="index"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </template>
        </el-input>
      </div>
    </div>
    <!-- 表格 -->
    <el-table
      ref="multipleTable"
      :data="washingMachineListData"
      tooltip-effect="dark"
      style="width: 100%"
      :border="false"
      :header-cell-style="{ backgroundColor: '#F4F7FB' }"
      :header-row-style="{
        backgroundColor: '#F4F7FB',
        color: '#1E2026',
      }"
      @selection-change="
        (value) => {
          checkedData = value.map((item) => item.id);
        }
      "
    >
      <el-table-column
        type="selection"
        :width="$store.state.screenWidth > 1200 ? 55 : 30"
      />
      <el-table-column prop="sort" label="排序" width="100" v-if="data.id">
        <template #header>
          <span
            :style="washingMachineList_req.type !== '' ? 'color:#059669;' : ''"
            >排序</span
          >
          <el-tooltip
            class="box-item"
            effect="dark"
            content="点击数字更改排序，值大的排在前面"
            placement="right"
          >
            <el-icon style="margin-left: 4px; cursor: pointer"
              ><QuestionFilled
            /></el-icon>
          </el-tooltip>
        </template>
        <template #default="scope">
          <el-input
            class="sort"
            @focus="
              ($event) => {
                form.event = $event.target;
                washingMachineListEditor(scope.row, false);
              }
            "
            @change="sortChange"
            v-model="scope.row.sort"
            maxlength="5"
            style="width: 64px"
            :formatter="(value) => value.replace(/\D/g, '')"
          />
        </template>
      </el-table-column>
      <el-table-column prop="name" label="设备信息" min-width="200">
        <template #default="scope">
          <div class="text">
            <el-link type="primary" @click="washingMachineListEditor(scope.row)"
              >名称：{{ scope.row.name }}</el-link
            >
          </div>
          <div class="text" @click="onCopy(scope.row.devid)">
            <el-text class="text-info" type="info">
              ID：{{ scope.row.devid }}
            </el-text>
            <el-icon><CopyDocument /></el-icon>
          </div>
          <div class="text" v-if="scope.row.remark">
            备注：{{ scope.row.remark || "--" }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="type" class-name="screen" min-width="150">
        <template #header>
          <span
            :style="washingMachineList_req.type !== '' ? 'color:#059669;' : ''"
            >设备类型</span
          >
          <el-dropdown
            trigger="click"
            popper-class="dropdown"
            @command="handleCommand4"
          >
            <el-icon><ArrowDown /></el-icon>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item
                  command=""
                  :class="washingMachineList_req.type === '' ? 'index' : ''"
                  >全部</el-dropdown-item
                >
                <el-dropdown-item
                  :command="item.id"
                  :class="
                    washingMachineList_req.type === item.id ? 'index' : ''
                  "
                  v-for="item in deviceTypeData"
                  :key="item.id"
                  >{{ item.name }}</el-dropdown-item
                >
              </el-dropdown-menu>
            </template>
          </el-dropdown></template
        >
        <template #default="scope">
          <el-tag
            v-if="deviceTypeData.length"
            disable-transitions
            :type="
              deviceTypeData.find((item) => item.id == scope.row.type).type
            "
            >{{
              deviceTypeData.find((item) => item.id == scope.row.type).name
            }}</el-tag
          >
          <div v-else>--</div>
        </template>
      </el-table-column>
      <el-table-column prop="cid" class-name="screen" min-width="150">
        <template #header>
          <span
            :style="washingMachineList_req.cid !== '' ? 'color:#059669;' : ''"
            >设备厂商</span
          >
          <el-dropdown
            trigger="click"
            popper-class="dropdown"
            @command="handleCommand"
          >
            <el-icon><ArrowDown /></el-icon>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item
                  command=""
                  :class="washingMachineList_req.cid === '' ? 'index' : ''"
                  >全部</el-dropdown-item
                >
                <el-dropdown-item
                  :command="item.cid"
                  :class="
                    washingMachineList_req.cid === item.cid ? 'index' : ''
                  "
                  v-for="item in deviceMgrData"
                  :key="item.id"
                  >{{ item.name }}</el-dropdown-item
                >
              </el-dropdown-menu>
            </template>
          </el-dropdown></template
        >
        <template #default="scope">
          <el-tag
            v-if="deviceMgrData.length"
            disable-transitions
            type="primary"
            >{{
              deviceMgrData.find((item) => item.cid == scope.row.cid).name
            }}</el-tag
          >
          <div v-else>--</div>
        </template>
      </el-table-column>
      <el-table-column prop="online" class-name="screen" min-width="150">
        <template #header>
          <span
            :style="
              washingMachineList_req.online !== '' ? 'color:#059669;' : ''
            "
            >设备状态</span
          >
          <el-dropdown
            trigger="click"
            popper-class="dropdown"
            @command="handleCommand2"
          >
            <el-icon><ArrowDown /></el-icon>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item
                  command=""
                  :class="washingMachineList_req.online === '' ? 'index' : ''"
                  >全部</el-dropdown-item
                >
                <el-dropdown-item
                  :command="item.id"
                  :class="
                    washingMachineList_req.online === item.id ? 'index' : ''
                  "
                  v-for="item in deviceOnlineMap"
                  :key="item.id"
                  >{{ item.name }}</el-dropdown-item
                >
              </el-dropdown-menu>
            </template>
          </el-dropdown></template
        >
        <template #default="scope">
          <el-tag
            disable-transitions
            :type="scope.row.online ? 'success' : 'danger'"
            >{{ deviceOnlineMap[scope.row.online].name }}</el-tag
          >
        </template>
      </el-table-column>
      <el-table-column prop="run_text" label="工作状态" min-width="200">
        <template #default="scope">
          <div class="text" style="font-weight: bold">
            {{ scope.row.run_text || "--" }}
          </div>
          <div
            class="text"
            v-if="scope.row.oktime && scope.row.oktime * 1000 > Date.now()"
          >
            <el-text type="success" style="cursor: not-allowed">
              剩余{{
                Math.ceil((scope.row.oktime * 1000 - Date.now()) / 60000)
              }}分钟
            </el-text>
          </div>
          <div class="text" v-if="scope.row.err_msg">
            <el-text type="error" style="cursor: not-allowed">
              {{ scope.row.err_msg || "--" }}
            </el-text>
          </div>
          <div class="text" v-if="scope.row.logtime">
            <el-text type="info" style="cursor: not-allowed">
              {{
                $moment(scope.row.logtime * 1000).format("yyyy-MM-DD HH:mm:ss")
              }}
            </el-text>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="err_msg"
        label="故障说明"
        min-width="150"
        show-overflow-tooltip
        v-if="false"
        :formatter="
          (row, column, cellValue) => {
            return cellValue || '--';
          }
        "
      >
      </el-table-column>
      <el-table-column prop="name" label="门店信息" min-width="150">
        <template #default="scope">
          <template v-if="scope.row.hotelInfo">
            <div>
              <el-text type="primary">{{ scope.row.hotelInfo.name }}</el-text>
            </div>
            <div
              class="info"
              style="cursor: pointer"
              @click="onCopy(scope.row.hotelInfo.code)"
            >
              <el-text type="info">{{ scope.row.hotelInfo.code }}</el-text>
              <el-icon><CopyDocument /></el-icon>
            </div>
          </template>
          <div v-else>--</div>
        </template>
      </el-table-column>
      <el-table-column
        label="备注"
        min-width="150"
        show-overflow-tooltip
        v-if="false"
      >
        <template #default="scope">
          {{ scope.row.remark || "--" }}
        </template>
      </el-table-column>
      <el-table-column label="状态" min-width="80">
        <template #header>
          <span
            :style="
              washingMachineList_req.online !== '' ? 'color:#059669;' : ''
            "
            >状态</span
          >
          <el-dropdown
            trigger="click"
            popper-class="dropdown"
            @command="handleCommand3"
          >
            <el-icon><ArrowDown /></el-icon>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item
                  command=""
                  :class="washingMachineList_req.state === '' ? 'index' : ''"
                  >全部</el-dropdown-item
                >
                <el-dropdown-item
                  :command="item.id"
                  :class="
                    washingMachineList_req.state === item.id ? 'index' : ''
                  "
                  v-for="item in stateMap"
                  :key="item.id"
                  >{{ item.name }}</el-dropdown-item
                >
              </el-dropdown-menu>
            </template>
          </el-dropdown></template
        >
        <template #default="scope">
          <el-switch
            v-model="scope.row.state"
            :active-value="1"
            :inactive-value="0"
            @change="stateChange(scope.row)"
          />
        </template>
      </el-table-column>
      <el-table-column label="绑定时间" min-width="100">
        <template #default="scope">
          <template v-if="scope.row.addtime">
            {{ $moment(scope.row.addtime * 1000).format("yyyy-MM-DD") }}
          </template>
          <template v-else> -- </template>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        :width="data.id ? 160 : 220"
        :fixed="$store.state.screenWidth > 1200 ? 'right' : false"
      >
        <template #default="scope">
          <el-button
            link
            type="primary"
            @click="washingMachineListEditor(scope.row)"
            >编辑</el-button
          >
          <el-divider direction="vertical"></el-divider>
          <el-button
            v-if="scope.row.hotel_id"
            link
            type="primary"
            @click="washingMachineListUnbind(scope.row.id)"
            >解绑</el-button
          >
          <el-button
            v-else
            link
            type="primary"
            @click="washingMachineListbind(scope.row)"
            >绑定</el-button
          >
          <el-divider
            direction="vertical"
            v-if="
              deviceMgrData.length != 0 &&
              (deviceMgrData.find((item) => item.cid == scope.row.cid) || {})
                .hasDetail
            "
          ></el-divider>
          <el-button
            link
            type="primary"
            @click="washingMachineListReset(scope.row)"
            :disabled="scope.row.reset"
            v-if="
              deviceMgrData.length != 0 &&
              (deviceMgrData.find((item) => item.cid == scope.row.cid) || {})
                .hasDetail
            "
            >刷新</el-button
          >
          <el-divider direction="vertical" v-if="!data.id"></el-divider>
          <el-button
            link
            type="primary"
            @click="washingMachineListDel(scope.row.id)"
            v-if="!data.id"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- 页码 -->
    <el-pagination
      background
      :pager-count="$store.state.screenWidth > 1200 ? 7 : 5"
      :page-sizes="[10, 20, 100, 200, 500, 1000]"
      layout="prev,pager,next,sizes,slot"
      v-model:current-page="washingMachineList_req.page"
      v-model:page-size="washingMachineList_req.page_max"
      :total="tableCount"
    >
      <div class="statistical">
        每页<b style="color: #ff0000">{{ washingMachineList_req.page_max }}</b
        >条/共<b style="color: #059669">{{ tableCount }}</b> 条数据
      </div>
    </el-pagination>
  </div>
</template>

<script setup>
import {
  reactive,
  ref,
  getCurrentInstance,
  onMounted,
  watch,
  nextTick,
  onActivated,
  defineProps,
} from "vue";
import { useStore } from "vuex";
import { ElMessage, ElMessageBox } from "element-plus";
import Province from "@/utils/full-citys.js";
//引入组件
import Explorer from "@/components/explorer.vue";
//父组件传递数据
let props = defineProps({
  drawer: Boolean,
  data: {
    type: Object,
    default: {},
  },
});
//获取公共方法
let { proxy } = getCurrentInstance();
//全局数据
let vuex = useStore();
//设备请求参数
let washingMachineList_req = reactive({
  cid: "",
  online: "",
  value: "",
  state: "",
  type: "",
  page: 1,
  page_max: 10,
});
//表单对象
let formRef = ref(null);
//设备表单数据
let form = reactive({
  cid: 1,
  devid: "",
  hotel_code: "",
  name: "",
  remark: "",
  sort: 0,
  state: 1,
});
//校验规则
let rules = reactive({
  devid: [{ required: true, message: "设备ID不能为空", trigger: "blur" }],
  hotel_code: [
    { required: true, message: "门店代码不能为空", trigger: "blur" },
  ],
  name: [{ required: true, message: "设备名称不能为空", trigger: "blur" }],
  cid: [{ required: true, message: "请选择设备厂商", trigger: "blur" }],
});
//表单对象
let formRef2 = ref(null);
//导入设备表单数据
let form2 = reactive({
  cid: "",
  store_id: "",
  devids: [],
});
//搜索设备
let selectData = {
  1: {
    label: "设备名称",
    value: 1,
    key: "name",
  },
  2: {
    label: "门店名称",
    value: 2,
    key: "hotel_name",
  },
  3: {
    label: "门店代码",
    value: 3,
    key: "hotel_code",
  },
  4: {
    label: "设备ID",
    value: 4,
    key: "devid",
  },
};
//多选数据
let checkedData = ref([]);
//设备厂商数据
let deviceMgrData = ref([]);
let deviceMgrMap = ref({});
let deviceTypeData = ref([
  {
    id: 1,
    name: "洗衣机",
    type: "success",
  },
  {
    id: 2,
    name: "烘干机",
    type: "warning",
  },
]);
//设备在线状态字典
let deviceOnlineMap = {
  1: {
    id: 1,
    name: "在线",
  },
  0: {
    id: 0,
    name: "离线",
  },
};
//设备是否启用字典
let stateMap = {
  1: {
    id: 1,
    name: "启用",
  },
  0: {
    id: 0,
    name: "禁用",
  },
};
//搜索id
let selectId = ref(1);
//设备数据
let washingMachineListData = ref([]);
//设备总数
let tableCount = ref(0);
//编辑/绑定设备弹窗状态
let dialogVisible = ref(false);
//导入设备弹窗状态
let dialogVisible2 = ref(false);
//洗衣机门店数据
let storesData = ref([]);
//洗衣机设备数据
let devicesData = ref([]);
//设备加载状态
let devicesLoading = ref(false);
//监听请求参数变化事件
watch(
  [
    () => washingMachineList_req.value,
    () => washingMachineList_req.page_max,
    () => washingMachineList_req.cid,
    () => washingMachineList_req.online,
    () => washingMachineList_req.type,
    () => washingMachineList_req.state,
    selectId,
  ],
  async (newValue, oldValue) => {
    if (washingMachineList_req.page == 1) {
      washingMachineListGet();
    } else {
      washingMachineList_req.page = 1;
    }
  }
);
watch([() => washingMachineList_req.page], async (newValue, oldValue) => {
  washingMachineListGet();
});
watch(
  () => form2.cid,
  async (newValue, oldValue) => {
    form2.devids = [];
    devicesData.value = [];
    form2.store_id = "";
    if (dialogVisible2.value) importGet();
  }
);
watch(
  () => form2.store_id,
  async (newValue, oldValue) => {
    form2.devids = [];
    if (dialogVisible2.value) devicesGet();
  }
);
//页面渲染事件
onMounted(() => {
  washingMachineListGet();
});
//页面重新渲染事件
onActivated(() => {
  deviceMgrGet();
});
//设备获取
function washingMachineListGet() {
  let req = {
    hotel_id: props.data.id || undefined,
    cid: washingMachineList_req.cid || undefined,
    type: washingMachineList_req.type || undefined,
    online:
      washingMachineList_req.online === ""
        ? undefined
        : washingMachineList_req.online,
    state:
      washingMachineList_req.state === ""
        ? undefined
        : washingMachineList_req.state,
    page: washingMachineList_req.page,
    page_max: washingMachineList_req.page_max,
  };
  req[selectData[selectId.value].key] = washingMachineList_req.value;
  proxy.$http
    .get(
      `webapi/${
        props.data.id ? "hotel_wash_device_mgr" : "wash_device_mgr"
      }?item=list`,
      {
        params: {
          ...req,
        },
      }
    )
    .then(({ data: res }) => {
      if (res.code == 0) {
        tableCount.value = res.data.count;
        res.data.list.forEach((item) => {
          item.hotelInfo = res.data.hotels.find(
            (item2) => item2.id == item.hotel_id
          );
        });
        washingMachineListData.value = res.data.list;
      }
    })
    .catch((err) => {
      console.log("请求失败");
    });
}
//导入设备数据获取
function importGet() {
  storesDataGet();
  devicesGet();
}
//洗衣机门店获取
function storesDataGet() {
  if (
    !props.data.code ||
    (form2.cid && !deviceMgrMap.value[form2.cid].hasStores)
  )
    return;
  proxy.$http
    .get(`webapi/hotel_wash_device_mgr?item=api_stores`, {
      params: {
        cid: form2.cid || undefined,
        hotel_id: props.data.id || undefined,
      },
    })
    .then(({ data: res }) => {
      if (res.code == 0) {
        storesData.value = res.data.list.map((item) => {
          return {
            cid: item.store_id,
            name: item.store_name,
          };
        });
      }
    })
    .catch((err) => {
      console.log("请求失败");
    });
}
//洗衣机设备获取
function devicesGet() {
  if (
    !props.data.code ||
    (form2.cid && deviceMgrMap.value[form2.cid].hasStores && !form2.store_id)
  )
    return;
  devicesLoading.value = true;
  proxy.$http
    .get(`webapi/hotel_wash_device_mgr?item=api_devices`, {
      params: {
        cid: form2.cid || undefined,
        hotel_id: props.data.id || undefined,
        store_id: form2.store_id || undefined,
      },
    })
    .then(({ data: res }) => {
      if (res.code == 0) {
        devicesData.value = res.data.list.map((item) => {
          return {
            ...item,
            cid: item.devid,
            name: item.cname,
          };
        });
      }
      devicesLoading.value = false;
    })
    .catch((err) => {
      console.log("请求失败");
      devicesLoading.value = false;
    });
}
//表格排序值变更事件
function sortChange(value) {
  form.sort = value || 0;
  form.event.blur();
  delete form.event;
  dialogSubmit();
}
//表格内状态变换事件
function stateChange(obj) {
  washingMachineListEditor(obj, false);
  dialogSubmit();
}
//弹窗确认事件
function dialogSubmit(formEl) {
  if (!formEl) return apiSend();
  formEl.validate((valid) => {
    if (valid) {
      apiSend();
    }
  });
}
function dialogSubmit2(formEl) {
  if (!formEl) return apiSend2();
  formEl.validate((valid) => {
    if (valid) {
      apiSend2();
    }
  });
}
//绑定请求
function apiSend() {
  let req = {};
  if (form.bindChange) {
    req = {
      id: form.id,
      hotel_code: form.hotel_code,
    };
  } else {
    req = { ...form };
  }
  if (props.data.id) {
    req.hotel_id = props.data.id;
    req.hotel_code = undefined;
  }
  proxy.$http
    .post(
      `webapi/${props.data.id ? "hotel_" : ""}wash_device_mgr?item=${
        form.bindChange ? "change_hotel" : form.id ? "set" : "bind"
      }`,
      {
        ...req,
      },
      {
        timeout: 12000, // 12秒超时
      }
    )
    .then(({ data: res }) => {
      if (res.code == 0) {
        ElMessage({
          message: `${
            form.bindChange ? "绑定" : form.id ? "编辑" : "绑定"
          }成功！`,
          type: "success",
        });
        dialogVisible.value = false;
        washingMachineListGet();
      } else {
        ElMessage({
          message: `${
            form.bindChange ? "绑定" : form.id ? "编辑" : "绑定"
          }失败！`,
          type: "error",
        });
      }
    })
    .catch((err) => {
      console.log("请求失败");
    });
}
//导入请求
function apiSend2() {
  let req = {};
  req = { ...form2 };
  proxy.$http
    .post(
      `webapi/hotel_wash_device_mgr?item=api_import`,
      {
        ...req,
        hotel_id: props.data.id || undefined,
      },
      {
        timeout: 12000, // 12秒超时
      }
    )
    .then(({ data: res }) => {
      if (res.code == 0) {
        ElMessage({
          message: `导入成功！`,
          type: "success",
        });
        dialogVisible2.value = false;
        washingMachineListGet();
      } else {
        ElMessage({
          message: `导入失败！`,
          type: "error",
        });
      }
    })
    .catch((err) => {
      console.log("请求失败");
    });
}
//编辑设备
function washingMachineListEditor(obj, show = true) {
  form.id = obj.id;
  form.name = obj.name;
  form.remark = obj.remark;
  form.cid = obj.cid;
  form.devid = obj.devid;
  form.hotel_code = obj.hotel_code;
  form.sort = obj.sort;
  form.state = obj.state;
  dialogVisible.value = show;
}
//改绑设备
function washingMachineListbind(obj) {
  form.id = obj.id;
  form.name = obj.name;
  form.remark = obj.remark;
  form.cid = obj.cid;
  form.devid = obj.devid;
  form.hotel_code = "";
  form.sort = obj.sort;
  dialogVisible.value = true;
  form.bindChange = true;
}
//解绑设备
function washingMachineListUnbind(id, type) {
  if (type == "all") {
    id = id.join(",");
    if (!id)
      return ElMessage({
        message: `请选择设备`,
        type: "warning",
      });
  }
  ElMessageBox.confirm(
    `此操作将解绑${type == "all" ? "选中" : "该"}设备, 是否继续?`,
    "提示",
    {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    }
  )
    .then(() => {
      proxy.$http
        .post(
          `webapi/${props.data.id ? "hotel_" : ""}wash_device_mgr?item=unbind`,
          {
            id,
            hotel_id: props.data.id || undefined,
          }
        )
        .then(({ data: res }) => {
          if (res.code == 0) {
            ElMessage({
              message: `解绑成功！`,
              type: "success",
            });
            dialogVisible.value = false;
            washingMachineListGet();
          } else {
            ElMessage({
              message: `解绑失败！`,
              type: "error",
            });
          }
        })
        .catch((err) => {
          console.log("请求失败");
        });
    })
    .catch(() => {
      console.log("取消");
    });
}
//删除设备
function washingMachineListDel(id, type) {
  if (type == "all") {
    id = id.join(",");
    if (!id)
      return ElMessage({
        message: `请选择设备`,
        type: "warning",
      });
  }
  ElMessageBox.confirm(
    `此操作将删除${type == "all" ? "选中" : "该"}设备, 是否继续?`,
    "提示",
    {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    }
  )
    .then(() => {
      proxy.$http
        .post(
          `webapi/${props.data.id ? "hotel_" : ""}wash_device_mgr?item=del`,
          {
            id,
            hotel_id: props.data.id || undefined,
          }
        )
        .then(({ data: res }) => {
          if (res.code == 0) {
            ElMessage({
              message: `删除成功！`,
              type: "success",
            });
            dialogVisible.value = false;
            washingMachineListGet();
          } else {
            ElMessage({
              message: `删除失败！`,
              type: "error",
            });
          }
        })
        .catch((err) => {
          console.log("请求失败");
        });
    })
    .catch(() => {
      console.log("取消");
    });
}
//刷新设备信息
function washingMachineListReset(obj) {
  obj.reset = true;
  proxy.$http
    .post(
      `webapi/${props.data.id ? "hotel_" : ""}wash_device_mgr?item=pull_detail`,
      {
        id: obj.id,
        hotel_id: props.data.id || undefined,
      },
      {
        timeout: 12000, // 12秒超时
      }
    )
    .then(({ data: res }) => {
      if (res.code == 0) {
        ElMessage({
          message: `刷新成功！`,
          type: "success",
        });
        washingMachineListGet();
      } else {
        obj.reset = false;
        ElMessage({
          message: `刷新失败！`,
          type: "error",
        });
      }
    })
    .catch((err) => {
      obj.reset = false;
      console.log("请求失败");
    });
}
//弹窗关闭事件
function dialogClosed() {
  formRef.value.resetFields();
  form.id = undefined;
  form.bindChange = undefined;
  form.cid = 1;
  form.devid = "";
  form.name = "";
  form.remark = "";
  form.hotel_code = "";
}
//导入设备弹窗关闭事件
function dialogClosed2() {
  formRef2.value.resetFields();
  form2.cid = "";
  form2.hotel_code = "";
  form2.store_id = "";
  form2.devids = [];
  devicesData.value = [];
}
//设备厂商获取
function deviceMgrGet() {
  proxy.$http
    .get(
      `webapi/${
        props.data.id ? "hotel_wash_device_mgr" : "wash_device_mgr"
      }?item=companys`,
      {
        params: {
          hotel_id: props.data.id || undefined,
        },
      }
    )
    .then(({ data: res }) => {
      if (res.code == 0) {
        let map = {};
        res.data.forEach((item) => {
          map[item.cid] = item;
        });
        deviceMgrData.value = res.data;
        deviceMgrMap.value = map;
      }
    })
    .catch((err) => {
      console.log("请求失败");
    });
}
//设备厂商变换
function handleCommand(e) {
  washingMachineList_req.cid = e;
}
//设备在线状态变换
function handleCommand2(e) {
  washingMachineList_req.online = e;
}
//设备是否启用变换
function handleCommand3(e) {
  washingMachineList_req.state = e;
}
//设备类型变换
function handleCommand4(e) {
  washingMachineList_req.type = e;
}
//复制
function onCopy(copytext) {
  proxy.$copyText(copytext).then(
    function (e) {
      ElMessage({
        message: `【${copytext}】复制成功！`,
        type: "success",
      });
    },
    function (e) {
      ElMessage({
        message: `复制失败！`,
        type: "error",
      });
    }
  );
}
</script>

<style lang="scss" scoped>
@import "@/assets/css/washingMachine/washingMachineList.scss";
</style>